module.exports = __webpack_public_path__ + "static/media/mobile.5e93eb18.png";